import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { UpdateStandalonePayment } from '../../+state/stores.actions';
import { PossibleTips, StandalonePaymentOrder } from '../../types/StandalonePayment';
import { createNumberMask } from 'text-mask-addons';
import { StorePaymentTipComponent } from '../../store-payment-tip/store-payment-tip.component';

@Component({
  selector: 'app-standalone-payment-tip',
  templateUrl: './standalone-payment-tip.component.html',
  styleUrls: ['./standalone-payment-tip.component.scss']
})
export class StandalonePaymentTipComponent implements OnChanges {
  @Input() paymentData: StandalonePaymentOrder;
  @ViewChild(StorePaymentTipComponent) paymentTipComponent!: StorePaymentTipComponent; 
  
  constructor(private store: Store<any>) { }

  ngOnChanges(changes: SimpleChanges): void {
      if (this.paymentTipComponent.localTips.amountSelected != this.paymentData.amountSelected) {
        this.paymentTipComponent?.recalculateTips(this.paymentData.amountSelected);
      }
  }

  onTipChange(tip: PossibleTips): void {
    const payload = {
      tipPercentage: tip.tipPercentage*100
    };
    this.store.dispatch(new UpdateStandalonePayment(Number(this.paymentData.storeId), this.paymentData.id, payload));
  }

  getSelectedTipValue() : number {
    return this.paymentData.amountTip;
  }
}
